<template>
  <div class="min-vh-100">
    <card class="content py-4">
      <div class="row">
        <div class="image-container text-center"></div>

        <div class="col-12">
          <div class="card card-chart">
            <div class="card-header py-0">
              <div class="row mb-0 pb-0">
                <div class="col-12 text-left">
                  <h2 class="card-title">
                    Tarificateur Weedo Trust
                  </h2>
                  <h4 class="card-title text-muted">
                    <b>
                      Simulez votre tarif en fonction du volume de numéros à vérifier mensuellement
                    </b>
                  </h4>
                </div>

                <div class="col-12">
                  <div class="card pt-3">
                    <div class="row">
                        <div class="col-12 col-md-5">
                            <base-input
                            name="volume"
                            v-validate="'required|numeric|min_value:0'"
                            :error="getError('volume')"
                            v-model="volume"
                            placeholder="ex: 8000"
                            addon-left-icon="tim-icons icon-mobile"
                            required
                            type="number"
                            @input="showResults = false"
                            ></base-input>
                            <div class="row mb-10 justify-content-center mt-4">
                                <base-button type="info" @click="calculatePrice"
                                ><i class="tim-icons icon-calculator"></i>
                                Calculer mon tarif</base-button
                                >
                            </div>
                            <div v-if="showResults">
                                <div class="results active">
                                    <div class="result-row">
                                        <div class="label">Tarif unitaire :</div>
                                        <div class="value">{{ formatPrice(unitPrice) }}</div>
                                    </div>
                                    <div class="result-row">
                                        <div class="label">Volume mensuel :</div>
                                        <div class="value">{{volume}}</div>
                                    </div>
                                    <div class="result-row total">
                                        <div class="label"><b>Total mensuel :</b></div>
                                        <div class="value">{{ formatPrice(totalPrice) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-7">
                            <div class="pricing-table">
                            <div class="header-row">
                                <div class="header-col">Volume mensuel</div>
                                <div class="header-col">Prix unitaire</div>
                            </div>
                            <div class="row" v-for="(tier, index) in priceTiers" :key="index">
                                <div class="col">{{ formatTierRange(tier) }}</div>
                                <div class="col">{{ formatPrice(tier.price) }}</div>
                            </div>
                            </div>
                        </div>


                      <div class="col-12 col-md-5">

                      </div>

                      <!-- <div class="col-12 col-md-8">
                        <label class="text-white mb-2">Pays cible :</label>
                        <el-select
                          v-model="selectedCountry"
                          placeholder="Sélectionnez un pays"
                          class="w-100"
                        >
                          <el-option
                            v-for="(country, code) in countries"
                            :key="code"
                            :label="country"
                            :value="code"
                          ></el-option>
                        </el-select>
                      </div> -->

                      <!-- Tableau des tarifs -->
                      <div class="col-12 col-md-8 mt-4">

                      </div>

                      <!-- Résultats -->

                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <!-- <div v-if="erreur">
            <base-alert type="default">
              <span>
                <template> {{ erreur }} </template>
              </span>
            </base-alert>
          </div> -->
        </div>
      </div>
    </card>

  </div>
</template>

<script>
import { BasePagination, Modal, BaseAlert } from "src/components";
import Modal_selfEvent from "src/components/Modal_selfEvent";
import { Select, Option } from "element-ui";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    BaseAlert,
    Modal_selfEvent
  },
  name: "WeedoTarificateurComponent",

  data() {
    return {
      // Données pour le tarificateur
      volume: 0,
      selectedCountry: "fr",
      showResults: false,
      unitPrice: 0,
      totalPrice: 0,

      // Pays disponibles
      countries: {
        fr: "France",
        be: "Belgique",
        ch: "Suisse",
        other: "Autre"
      },

      // Niveaux de prix
      priceTiers: [
        { max: 4999, price: 0.25 },
        { max: 9999, price: 0.23 },
        { max: 24999, price: 0.21 },
        { max: 49999, price: 0.19 },
        { max: 99999, price: 0.18 },
        { max: Infinity, price: 0.17 }
      ],
    };
  },

  mounted(){
    this.calculatePrice()

  },

  methods: {
    // Calcul du prix
    calculatePrice() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return;
        }

        const volume = parseInt(this.volume, 10);

        if(volume == 0){
            this.unitPrice = 0
        }else{
            // Trouver le tarif applicable
            for (const tier of this.priceTiers) {
                if (volume <= tier.max) {
                    this.unitPrice = tier.price;
                    break;
                }
            }
        }

        // Calculer le prix total
        this.totalPrice = this.unitPrice * volume;

        // Afficher les résultats
        this.showResults = true;
      });
    },

    // Formatage du prix
    formatPrice(price) {
      let prix = price.toFixed(2).replace('.', ',')
      return prix.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' €';
    },
    // Formatage des nombres
    /* formatNumber(number) {
      return number.toLocaleString('fr-FR');
    }, */

    // Formatage des plages de niveau de prix
    formatTierRange(tier) {
      if (tier.max === Infinity) {
        return '100 000+';
      }

      // Trouver le niveau de prix précédent pour déterminer la valeur minimale
      const index = this.priceTiers.indexOf(tier);
      const min = index > 0 ? this.priceTiers[index - 1].max + 1 : 1;

      return `${min.toLocaleString('fr-FR')} - ${tier.max.toLocaleString('fr-FR')}`;
    },

    // Gestion des erreurs de validation
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  }
};
</script>

<style scoped>
/* Styles du tarificateur */
.pricing-table {
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.pricing-table .header-row {
  display: flex;
  background-color: #9168c9;
  padding: 15px;
}

.pricing-table .header-col {
  flex: 1;
  font-weight: bold;
  color: white;
}

.pricing-table .row {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #2d3748;
}

.pricing-table .row:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.1);
}

.pricing-table .col {
  flex: 1;
}

.results {
  margin-top: 20px;
  padding: 20px;
  background-color: #1e1e2d;
  border-radius: 8px;
}

.result-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #2d3748;
}

.result-row:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.result-row .label {
  color: #a0aec0;
}

.result-row .value {
  font-weight: bold;
}

.result-row.total {
  margin-top: 20px;
  font-size: 1.2rem;
}

.result-row.total .value {
  color: #5ac18c;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

</style>
